import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../../../../toolkit/uicomponentcss';
import { Colors } from '../../../../../utils/resources/colors';

export interface ManageGroupCSSStyle extends UIComponentCSSStyle {
    getGroupTitleCSSStyle(): object;
    getGroupNameCSSStyle(): object;
    getGroupMembersCSSStyle(): object;
    getButtonDivCSSStyle():object;
}

export class ManageGroupCSSStyleImpl extends UIComponentCSSStyleImpl implements ManageGroupCSSStyle 
{
 
    getWrapperCSSStyle(): object
    {
        return{
            width: "100%",
            textAlign: "center",
        };
    }

    getGroupNameCSSStyle(): object 
    {
        return {
            display: "inline-block"

        };
    }
    getGroupTitleCSSStyle(): object {
        return {

            textAlign: "center",
            
            color: this.getResources().getColor(Colors.color_4),
            fontFamily: this.getResources().getFontFamily(),
            fontWeight: 900,
            letterSpacing: 0,
            boxSizing: "border-box",
            // height: "60px",
            width: "100%",
          };
    }

    getGroupMembersCSSStyle(): object {
       return {
           
            // marginRight: this.getContext().getUserContext().getLanguage() === LanguageConst.FRENCH ? "0px" : "5%",
            height: "100%",
            display: "inline-block"
       };
    }

    getButtonDivCSSStyle():object
    {
        return{
       
        };
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/groups/managegroup/managegroupcss.tsx